import React from "react";
import "./App.css";

import Home from "./pages/Homepage";
import Gallery from "./pages/Gallery";
import Documents from "./pages/Documents";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { GlobalProvider } from "./context/GlobalState";

function App() {
  return (
    <GlobalProvider>
      <Router>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/documente">
            <Documents />
          </Route>
          <Route path="/galerie">
            <Gallery />
          </Route>
        </Switch>
        {/* <Footer /> */}
      </Router>
    </GlobalProvider>
  );
}

export default App;
